import React from "react";
import sectionImage from "../../images/image 33.svg";
import frame21 from "../../images/Frame 21.svg";
import frame22 from "../../images/Frame 22.svg";
import frame23 from "../../images/Frame 23.svg";

const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const ConcentricCircles = () => (
	<svg
		width="1049"
		height="411"
		viewBox="0 0 748 406"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		preserveAspectRatio="xMinYMin meet"
		style={{ display: "block" }}
	>
		<g opacity="0.5">
			<mask id="mask0_2409_1338" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="-302" y="0" width="1050" height="412">
				<rect x="-300.936" y="1.064" width="1047.68" height="409.153" fill="#133523" fillOpacity="0.4" stroke="#29645B" strokeWidth="2.12837" />
			</mask>
			<g mask="url(#mask0_2409_1338)">
				<path opacity="0.6" d="M222.902 288.592C299.405 288.592 361.203 343.639 361.203 411.284C361.203 478.93 299.405 533.977 222.902 533.977C146.399 533.977 84.6022 478.93 84.6021 411.284C84.6021 343.639 146.399 288.592 222.902 288.592Z" fill="#133523" fillOpacity="0.4" stroke="#ADD5FF" strokeWidth="2.12837" />
				<path opacity="0.5" d="M222.902 232.014C334.591 232.014 424.911 312.39 424.911 411.281C424.911 510.172 334.591 590.548 222.902 590.548C111.212 590.548 20.892 510.172 20.892 411.281C20.892 312.389 111.213 232.014 222.902 232.014Z" fill="#133523" fillOpacity="0.4" stroke="#ADD5FF" strokeWidth="2.12837" />
				<path opacity="0.4" d="M222.907 171.902C371.981 171.903 492.607 279.19 492.607 411.279C492.607 543.368 371.981 650.657 222.907 650.657C73.8331 650.657 -46.7939 543.368 -46.7939 411.279C-46.7939 279.19 73.8332 171.902 222.907 171.902Z" fill="#133523" fillOpacity="0.4" stroke="#ADD5FF" strokeWidth="2.12837" />
				<path opacity="0.3" d="M222.908 101.187C415.964 101.187 572.246 240.137 572.246 411.282C572.245 582.428 415.964 721.377 222.908 721.377C29.8517 721.377 -126.43 582.428 -126.43 411.282C-126.43 240.137 29.8515 101.187 222.908 101.187Z" fill="#133523" fillOpacity="0.4" stroke="#ADD5FF" strokeWidth="2.12837" />
				<path opacity="0.2" d="M222.904 19.863C466.54 19.863 663.824 195.223 663.824 411.284C663.824 627.345 466.54 802.706 222.904 802.706C-20.7314 802.706 -218.016 627.345 -218.016 411.284C-218.015 195.223 -20.7314 19.8631 222.904 19.863Z" fill="#133523" fillOpacity="0.4" stroke="#ADD5FF" strokeWidth="2.12837" />
				<path opacity="0.1" d="M222.904 -68.5376C521.518 -68.5376 763.371 146.4 763.371 411.281C763.371 676.162 521.518 891.1 222.904 891.1C-75.7095 891.1 -317.562 676.162 -317.562 411.281C-317.562 146.4 -75.7094 -68.5375 222.904 -68.5376Z" fill="#133523" fillOpacity="0.4" stroke="#ADD5FF" strokeWidth="2.12837" />
				<path d="M222.907 355.771C257.627 355.772 285.552 380.739 285.552 411.281C285.552 441.823 257.627 466.792 222.907 466.792C188.187 466.792 160.262 441.823 160.262 411.281C160.262 380.739 188.187 355.771 222.907 355.771Z" fill="#133523" fillOpacity="0.4" stroke="#ADD5FF" strokeWidth="2.12837" />
			</g>
		</g>
	</svg>
);

const ZForHer = () => {
	return (
		<>
			<style>{`
				@media (max-width: 767px) {
					.zforher-circles {
						display: none !important;
					}
					.zforher-wrapper {
						flex-direction: column !important;
						padding: 60px 24px !important;
						gap: 24px !important;
						min-height: calc(100svh - 88px) !important;
					}
					.zforher-image {
						display: none !important;
					}
					.zforher-mobile-image {
						display: block !important;
						width: 100% !important;
						max-width: 100% !important;
						height: 289px !important;
						border-radius: 4.79px !important;
						object-fit: cover !important;
					}
					.zforher-content {
						min-width: 0 !important;
						width: 100% !important;
						min-height: calc(100svh - 208px) !important;
						display: flex !important;
						flex-direction: column !important;
					}
					.zforher-tier-cards {
						width: 100% !important;
						max-width: 100% !important;
						height: 80px !important;
						gap: 4px !important;
						margin-top: 24px !important;
					}
					.zforher-tier-cards img {
						width: 107px !important;
						max-width: 107px !important;
						height: 80px !important;
						flex: 0 0 107px !important;
						object-fit: contain !important;
						border-radius: 8px !important;
						box-shadow: 0px 32px 40px -12px #0A0D1214 !important;
					}
					.zforher-buttons {
						display: flex !important;
						flex-wrap: wrap !important;
					}
					.zforher-learn-more {
						display: none !important;
					}
				}
			`}</style>

			<section
				style={{
					width: "100%",
					backgroundColor: "#132A22",
					boxSizing: "border-box",
					overflow: "hidden",
					position: "relative",
				}}
			>
				<div
					className="zforher-circles"
					style={{
						position: "absolute",
						bottom: "0",
						left: "0",
						width: "clamp(520px, 58vw, 920px)",
						height: "411px",
						opacity: 0.5,
						pointerEvents: "none",
						zIndex: 0,
						transform: "translate(-14%, 18%)",
					}}
				>
					<ConcentricCircles />
				</div>

				<div style={{ position: "relative", zIndex: 1 }}>
					<div
						className="zforher-wrapper"
						style={{
							maxWidth: "1440px",
							margin: "0 auto",
							padding: "clamp(48px, 6.94vw, 100px) clamp(20px, 5.56vw, 80px)",
							display: "flex",
							alignItems: "center",
							gap: "clamp(24px, 5.76vw, 83px)",
							boxSizing: "border-box",
							flexWrap: "wrap",
						}}
					>
						{/* Left — image */}
						<img
							className="zforher-image"
							src={sectionImage}
							alt="Woman entrepreneur using Zikora MFB"
							style={{
								width: "clamp(200px, 40.6vw, 584px)",
								height: "clamp(240px, 49.2vw, 708px)",
								borderRadius: "16px",
								objectFit: "cover",
								flexShrink: 0,
							}}
						/>

						{/* Right — content column */}
						<div
							className="zforher-content"
							style={{
								flex: 1,
								minWidth: "260px",
								display: "flex",
								flexDirection: "column",
							}}
						>
							<div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
								{/* FOR HER, BY US label */}
								<div
									style={{
										display: "inline-flex",
										alignItems: "center",
										gap: "8px",
										alignSelf: "flex-start",
									}}
								>
									<span
										style={{
											width: "8px",
											height: "8px",
											borderRadius: "50%",
											backgroundColor: "#86C7A8",
											flexShrink: 0,
											display: "inline-block",
										}}
									/>
									<span
										style={{
											fontFamily: "'Geist Mono', monospace",
											fontWeight: 500,
											fontSize: "14px",
											lineHeight: "32px",
											letterSpacing: "0px",
											textTransform: "uppercase",
											color: "#86C7A8",
											whiteSpace: "nowrap",
										}}
									>
										For Her, By Us
									</span>
								</div>

								<h2
									style={{
										...instrumentSerif,
										fontWeight: 400,
										fontSize: "clamp(28px, 4.17vw, 60px)",
										lineHeight: "clamp(36px, 4.86vw, 70px)",
										color: "#FFFFFF",
										margin: 0,
									}}
								>
									Meet <span style={{ color: "#86C7A8" }}>Z-ForHer</span>, flexible<br />
									credit that grows with<br />
									your hustle.
								</h2>

								<p
									style={{
										fontFamily: "'Geist', sans-serif",
										fontWeight: 500,
										fontSize: "clamp(14px, 1.39vw, 20px)",
										lineHeight: "1.6",
										letterSpacing: 0,
										color: "#DEDEDE",
										margin: 0,
									}}
								>
									Access funds when you need them, repay with ease, and draw again
									without starting over.
									</p>
								</div>

								<img
									className="zforher-mobile-image"
									src={sectionImage}
									alt="Woman entrepreneur using Zikora MFB"
									style={{
										display: "none",
										width: "100%",
										height: "289px",
										borderRadius: "4.79px",
										objectFit: "cover",
										flexShrink: 0,
									}}
								/>

								{/* Tier cards */}
								<div
								className="zforher-tier-cards"
								style={{
									display: "flex",
									gap: "clamp(3px, 1.11vw, 15px)",
									marginTop: "clamp(24px, 2.78vw, 40px)",
									alignItems: "flex-start",
									overflow: "visible",
								}}
							>
								<img
									src={frame21}
									alt="Starter — Up to ₦50,000"
									style={{ flex: "1 1 0", minWidth: 0, height: "auto", maxWidth: "185px" }}
								/>
								<img
									src={frame22}
									alt="Growth — Up to ₦200,000"
									style={{ flex: "1 1 0", minWidth: 0, height: "auto", maxWidth: "184px" }}
								/>
								<img
									src={frame23}
									alt="Premium — Up to ₦500,000"
									style={{ flex: "1 1 0", minWidth: 0, height: "auto", maxWidth: "185px" }}
								/>
							</div>

							{/* Buttons */}
								<div
									className="zforher-buttons"
									style={{
										display: "flex",
										alignItems: "center",
										gap: "12px",
										marginTop: "16px",
										flexWrap: "wrap",
									}}
								>
								<a
									href="https://zikoramfb.qoreonline.com/onboarding/type"
									target="_blank"
									rel="noopener noreferrer"
									style={{
										fontFamily: "'Geist', sans-serif",
										height: "clamp(44px, 3.61vw, 52px)",
										backgroundColor: "#86C7A8",
										borderRadius: "8px",
										padding: "0 16px",
										fontWeight: 600,
										fontSize: "clamp(13px, 1.11vw, 16px)",
										lineHeight: "20px",
										color: "#132A22",
										textDecoration: "none",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										whiteSpace: "nowrap",
										boxSizing: "border-box",
									}}
								>
									Apply for Z-ForHer
								</a>

								<a
									className="zforher-learn-more"
									href="/loans"
									style={{
										fontFamily: "'Geist', sans-serif",
										height: "clamp(44px, 3.61vw, 52px)",
										backgroundColor: "transparent",
										border: "1px solid #DEDEDE",
										borderRadius: "8px",
										padding: "0 16px",
										fontWeight: 600,
										fontSize: "clamp(13px, 1.11vw, 16px)",
										lineHeight: "20px",
										color: "#FFFFFF",
										textDecoration: "none",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										whiteSpace: "nowrap",
										boxSizing: "border-box",
									}}
								>
									Learn More
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default ZForHer;
